import { ProgressReportMasterDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProgressMasterActions from './progress-master.actions';

export const PROGRESS_MASTER_FEATURE_KEY = 'progressMaster';

export interface ProgressMasterState
  extends EntityState<ProgressReportMasterDto> {
  selectedProgressMasterId?: string | number; // which ProgressMaster record has been selected
  loaded: boolean; // has the ProgressMaster list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProgressMasterPartialState {
  readonly [PROGRESS_MASTER_FEATURE_KEY]: ProgressMasterState;
}

export const progressMasterAdapter: EntityAdapter<ProgressReportMasterDto> = createEntityAdapter<
  ProgressReportMasterDto
>({
  selectId: (progressMaster) => progressMaster.id,
  sortComparer: false,
});

export const initialState: ProgressMasterState = progressMasterAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProgressMasterId: null,
  }
);

const progressMasterReducer = createReducer(
  initialState,
  on(ProgressMasterActions.loadProgressMaster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMasterActions.loadProgressMasterSuccess,
    (state, { progressMaster }) =>
      progressMasterAdapter.addAll(progressMaster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressMasterActions.loadProgressMasterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProgressMasterActions.addProgressMaster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMasterActions.addProgressMasterSuccess,
    (state, { newProgressMaster }) =>
      progressMasterAdapter.addMany(newProgressMaster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressMasterActions.addProgressMasterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProgressMasterActions.updateProgressMaster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMasterActions.updateProgressMasterSuccess,
    (state, { updateProgressMaster }) =>
      progressMasterAdapter.upsertMany(updateProgressMaster, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressMasterActions.updateProgressMasterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  // search student

  on(ProgressMasterActions.searchProgressMasterRecord, (state, { query }) => {
    return {
      ...state,
      selectedProgressMasterId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProgressMasterActions.removeProgressMaster, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProgressMasterActions.removeProgressMasterSuccess, (state, { ids }) =>
    progressMasterAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(ProgressMasterActions.removeProgressMasterFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(
  state: ProgressMasterState | undefined,
  action: Action
) {
  return progressMasterReducer(state, action);
}
